import React, { Component } from "react";
import FlyerImg from '../../images/flyer2-bg.png'
import FlyerText from '../../images/flyer2-text.png'
import jsPDF from 'jspdf'
import domtoimage from 'dom-to-image';
import CardBack from "../Summary/CardBack";
import CardFront from "../Summary/CardFront";

class FlyerPage2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zoom: false
        }
        this.printIndivisual = this.printIndivisual.bind(this);
        this.downloaddoc = this.downloaddoc.bind(this);
    }

    componentDidMount() {
    }
    printIndivisual(event, data) {
        const printElement = document.getElementById('flyer2')
        printElement.classList.add('isPrinting')
        var printableHtml = printElement.outerHTML;
        document.getElementById('root').innerHTML = printableHtml;
        setTimeout(() => {
            window.print();
            window.location.reload()
        }, 3000)
    }
    downloaddoc(id, name, event) {
        const printElement = document.getElementById('flyer2')
        printElement.style.maxHeight = 'none';
        printElement.style.overflow = 'auto';
        printElement.querySelector('.buttons').style.display = 'none'
        domtoimage.toPng(document.getElementById('flyer2'))
            .then(function (blob) {
                var doc = new jsPDF("p", "mm", "a4"); // Portrait mode
                var pdfWidth = doc.internal.pageSize.getWidth();
                var pdfHeight = doc.internal.pageSize.getHeight();

                var fixedWidth = pdfWidth - 20; // Keep margins

                var img = new Image();
                img.src = blob;
                img.onload = function () {
                    var imgWidth = img.width;
                    var imgHeight = img.height;

                    // Maintain aspect ratio
                    var fixedHeight = (imgHeight / imgWidth) * fixedWidth;

                    // If the image height is greater than the page, scale it down
                    if (fixedHeight > pdfHeight - 20) {
                        var scaleFactor = (pdfHeight - 20) / fixedHeight;
                        fixedWidth = fixedWidth * scaleFactor;
                        fixedHeight = fixedHeight * scaleFactor;
                    }

                    // If the content still does not fit, split into multiple pages
                    var y = 10; // Top margin
                    if (fixedHeight > pdfHeight - 20) {
                        var totalPages = Math.ceil(fixedHeight / (pdfHeight - 20));
                        var chunkHeight = (pdfHeight - 20);

                        for (var i = 0; i < totalPages; i++) {
                            var yOffset = -i * chunkHeight;
                            if (i > 0) doc.addPage();
                            doc.addImage(blob, 'JPEG', 10, y + yOffset, fixedWidth, fixedHeight);
                        }
                    } else {
                        doc.addImage(blob, 'JPEG', 10, y, fixedWidth, fixedHeight);
                    }

                    doc.save('flyer-1.pdf');

                    printElement.style.maxHeight = 'calc(100vh - 40px)';
                    printElement.style.overflowY = 'scroll';
                    printElement.querySelector('.buttons').style.display = 'flex'
                };
            });
    }
    render() {
        //let datetime = Math.floor(Math.random() * 1313131)
        //const mId = "AX" + datetime
        return (
            <div className="zoomedFlyerBox zoomedFlyerBox2 flyer-container" id="flyer2">
                <div className="buttons">
                    <div className="download" onClick={this.downloaddoc.bind(this)}></div>
                    <div className="print" onClick={this.printIndivisual.bind(this)}></div>
                </div>
                <div className="flyer-image">
                    <img src={FlyerImg} />
                </div>
                <div className="flyer-card">
                    <CardFront bin={this.props.bin} pcn={this.props.pcn} classnames={this.props.classnames} PrimaryGn={this.props.groupNumber} mId={this.props.mId} />
                    <CardBack bin={this.props.bin} pcn={this.props.pcn} classnames={this.props.classnames} groupData={this.props.groupData} groupNumber={this.props.groupNumber} />
                </div>
                <div className="flyer-footer">
                    <img src={FlyerText} />
                </div>
            </div>
        );
    }
}
export default FlyerPage2;
